import { createFileRoute } from '@tanstack/react-router'
import { EmplacementView } from '@features/stock/components/EmplacementView'
import { usePermissions } from '@lib/hooks/usePermissions'
import { requirePermission } from '@lib/permissions/guards'
import { PERMISSIONS } from '@lib/permissions/permissions.generated'

export const Route = createFileRoute('/_app/stock/emplacements/$id/view')({
  beforeLoad: ({ context }) => {
    requirePermission(PERMISSIONS.STOCK.EMPLACEMENTS.VIEW, context)
  },
  component: ViewEmplacementComponent,
})

function ViewEmplacementComponent() {
  const { id } = Route.useParams()
  const { canView } = usePermissions()
    
  if (!canView('stock.emplacements.view')) {
    return <div className="p-6">Accès non autorisé</div>
  }

  return <EmplacementView id={Number(id)} />
}
